<div class="flex flex-column flex-justify-between"
     style="height:100%;"
     *ifSize="'SM'">
    <div class="b-b b-col-4 p-a p-b-3 flex flex-middle">
        <p class="fs-4 fw-bold">
            <span class="fw-bold">{{'Bag summary' | translate}}</span> <span
                  class="inline-block m-l-1">({{basket.qty}})</span>
        </p>
    </div>

    <div class="w-12 flex flex-column flex-grow overflow-y-auto scrollbar-none">
        <div class="wrap">
            <ul class="m-t-5">
                @for (item of basket.items | orderBy : ['data.added_at'] : ['desc']; track item.id) {
                <li>
                    <checkout-minibasket-item class="w-12"
                                              [class.m-b-2]="!$last"
                                              [item]="item" />
                </li>
                }
                @for (item of giftboxBasketItems | orderBy : ['data.added_at'] : ['desc']; track item.id) {
                @if (item?.product?.data) {
                <li>
                    <giftbox-checkout-item class="w-12 m-t-2"
                                           [item]="item" />
                </li>
                }
                }
            </ul>
            <!-- subtotal -->
            <ul class="m-t-3">
                <li class="flex flex-justify-between flex-middle">
                    <span class="fs-4">Subtotal</span>
                    <price class="price fs-4"
                           [value]="basket.totals?.subtotal"
                           [precision]="2" />
                </li>
                @if (checkoutFormComponent.shippingMethod) {
                <li class="flex flex-justify-between flex-middle m-t-3">
                    <span class="fs-4">{{checkoutFormComponent.shippingMethod?.title}}</span>
                    @if (basket.totals?.shipping === 0) {
                    <span>FREE</span>
                    } @else {
                    <price class="price fs-4"
                           [value]="basket.totals?.shipping"
                           [precision]="2" />
                    }
                </li>
                }
                @if (basket.data?.totals?.credits) {
                <li class="fs-4 m-t-3">
                    <store-credit-remove class="block"
                                         [isCheckout]="true" />
                </li>
                }
                @for (giftcard of basket.data.giftcards | values; track giftcard.code) {
                <li class="fs-4 m-t-3">
                    <giftcards-added-giftcard class="block"
                                              [giftcard]="giftcard" />
                </li>
                }

                <!-- discount -->
                @if (basket.discount) {
                <li class="fs-4 m-t-3">
                    <coupon-remove class="block" />
                </li>
                }


                <li class="flex flex-justify-between flex-middle fs-4 m-t-3 p-t-3 m-b-3 fw-bold b-t b-col-4">
                    <div>Order total</div>
                    <price [value]="basket.totals?.grand_total || 0"
                           [precision]="2" />
                </li>
            </ul>
        </div>
    </div>

    <div class="bg-col-w p-a p-t-5"
         style="box-shadow:-2px -1px 2px 1px rgba(0,0,0,.05)">
        <div class="flex flex-justify-between">
            <!-- content block -->
            <checkout-minibasket-content-block />

            <price class="price fs-4 fw-bold"
                   [value]="basket.totals?.grand_total || 0"
                   [precision]="2" />
        </div>
        <button class="button w-12 m-t"
                (click)="closePopup()">
            <span>{{'Back to checkout' | translate}}</span>
        </button>
    </div>
</div>

<!-- Desktop version-->
<div class="p-a bg-col-w"
     *ifSize="'XL'">
    <div class="flex flex-middle flex-justify-between">
        <p class="p1">{{'Bag summary' | translate}}</p>
    </div>
    <div class="m-t-3">
        <ul
            [ngClass]="{'checkout-minibasket-items overflow-y-scroll custom-scrollbar p-r-1' : basket.items.length > 2}">
            @for (item of basket.items | orderBy : ['data.added_at'] : ['desc']; track item.id) {
            <li>
                <checkout-minibasket-item class="w-12"
                                          [class.m-b-2]="!$last"
                                          [item]="item" />
            </li>
            }
            @for (item of giftboxBasketItems | orderBy : ['data.added_at'] : ['desc']; track item.id) {
            @if (item?.product?.data) {
            <li>
                <giftbox-checkout-item class="w-12 m-t-2"
                                       [item]="item" />
            </li>
            }
            }
        </ul>

        <!-- subtotal -->
        <ul class="m-t-3">

            <li class="flex flex-justify-between flex-middle">
                <span class="fs-4">Subtotal</span>
                <price class="price fs-4"
                       [value]="basket.totals?.subtotal"
                       [precision]="2" />
            </li>
            @if (checkoutFormComponent.shippingMethod) {
            <li class="flex flex-justify-between flex-middle m-t-3">
                <span class="fs-4">{{checkoutFormComponent.shippingMethod?.title}}</span>
                @if (basket.totals?.shipping === 0) {
                <span>FREE</span>
                } @else {
                <price class="price fs-4"
                       [value]="basket.totals?.shipping"
                       [precision]="2" />
                }
            </li>
            }
            @if (basket.data?.totals?.credits) {
            <li class="fs-4 m-t-3">
                <store-credit-remove class="block"
                                     [isCheckout]="true" />
            </li>
            }
            @for (giftcard of basket.data.giftcards | values; track giftcard.code) {
            <li class="fs-4 m-t-3">
                <giftcards-added-giftcard class="block"
                                          [giftcard]="giftcard"
                                          [useCheckoutPath]="true" />
            </li>
            }

            <!-- discount -->
            @if (basket.discount) {
            <li class="fs-4 m-t-3">
                <coupon-remove class="block" />
            </li>
            }
        </ul>

        <div class="flex flex-justify-between flex-middle m-t-3 m-b-1 p-t-3 b-t b-col-4">
            <!-- content block -->
            <checkout-minibasket-content-block />
        </div>
    </div>
</div>